export default {
  busProducts: [],
};
